module.exports = __webpack_public_path__ + "static/media/tutorial-action-list-7-1-1.e1b0dcd3.png";